// extracted by mini-css-extract-plugin
export var active = "_hv-e";
export var blink = "_hv-f";
export var dropDownSelector = "_hv-5";
export var dropDownWrapper = "_hv-4";
export var fakeCursor = "_hv-d";
export var fontSizeButton = "_hv-7";
export var formQuillEditor = "_hv-0";
export var pressed = "_hv-g";
export var qlBlank = "_hv-1";
export var textFormattingToolbar = "_hv-2";
export var textFormattingToolbarClosed = "_hv-3";
export var textFormattingToolbarInline = "_hv-6";
export var textToolbarOption = "_hv-8";
export var toolbarCell = "_hv-a";
export var toolbarCellCollapsed = "_hv-b";
export var toolbarOptionHitArea = "_hv-c";
export var toolbarOverflow = "_hv-9";